import { useInfiniteQuery } from '@tanstack/react-query'

import type { SmsActivityRepository } from './sms-activity-repository'

export function useSmsActivity(
  repository: SmsActivityRepository,
  tenantId: string
) {
  return useInfiniteQuery({
    queryKey: ['automated-sms-activity', tenantId],
    queryFn: ({ pageParam, signal }) =>
      repository.list(tenantId, pageParam, signal),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
  })
}
